import { Card, CardContent, Typography } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import Header from '../../../../components/Header';
import InfoIcon from '../../../../svg/InfoIcon';
import palette from '../../../../theme/palette';
import FileUploadContainer from '../../../../components/FileUploadContainer';

export default function UploadAsgn({ onBack, onFileSelect }) {
  const [file, setFile] = useState(null);
  return (
    <div style={{ marginTop: 20 }}>
      <Header title="Test Solution" onBack={onBack} />
      <Card style={{ marginTop: 15 }}>
        <CardContent
          style={{
            borderLeft: `9px solid ${palette.secondary.main}`,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <InfoIcon color={palette.secondary.main} style={{ marginRight: 10 }} />
          <p>This will be visible to students only after the test ends</p>
        </CardContent>
      </Card>
      <div style={{ marginTop: 35 }}>
        <Typography variant="subtitle1">Upload Solution</Typography>
        <Typography variant="subtitle2" style={{ marginBottom: 20 }}>
          Select one file at a time.You ca use PDF or image.
        </Typography>
        {file ? (
          <DownloadFileContainer title={file.name} onCancelClick={() => setFile(null)} />
        ) : (
          <FileUploadContainer
            onFileChange={(f) => {
              setFile(f);
              onFileSelect(f);
            }}
          />
        )}
      </div>
    </div>
  );
}

UploadAsgn.propTypes = {
  onBack: PropTypes.func,
  onFileSelect: PropTypes.func
};
